import React from "react"
import {makeStyles} from "@material-ui/core/styles"
import loading from "../../assets/images/loading.svg"

const useStyles = makeStyles(() => ({
  loading: {
    textAlign: `center`,
    zIndex: 100000000000,
  },
}))

const Loading = () => {
  const classes = useStyles()

  return (
    <div className={classes.loading}>
      <img src={loading} alt="Loading" />
    </div>
  )
}

export default Loading
